<div class="row">
    <div class="col-12">

        <div class="card">
            <div class="card-header">
                <div class="title">{{ 'TEMPLATES.CREATE_TEMPLATE' | translate }}</div>
                <div class="tools">
                    <!-- <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
                        <span aria-hidden="true">&times;</span>
                    </button> -->
                    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
                        <svg-icon  src="/assets/images/icons/close.svg" [stretch]="true"
                        [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                    </button>
                </div>
            </div>
            <div class="card-body">

                <nav>
                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                      <a *ngIf="permissionAccessService.check('ATTRIBUTES_MAPPING_LIST')" class="nav-link active" [ngClass]="{'active': switchTab === 'list'}" id="nav-list-tab" data-toggle="tab" href="#nav-list" role="tab" aria-controls="nav-list" aria-selected="true" (click)="switchTabs('list')">Список шаблонов</a>
                      <a *ngIf="permissionAccessService.check('ATTRIBUTES_MAPPING_CREATE') || permissionAccessService.check('ATTRIBUTES_MAPPING_UPDATE')"  class="nav-link" [ngClass]="{'active': switchTab === 'actions'}"  id="nav-actions-tab"  data-toggle="tab" href="#nav-actions" role="tab" aria-controls="nav-actions" aria-selected="true" (click)="switchTabs('actions')">Создание/редактирование шаблонов</a>
                    </div>
                </nav>

                    <div class="tab-content" id="nav-tabContent">

                        <!-- LIST -->
                        <div class="tab-pane fade active" id="nav-list" [ngClass]="{'show active': switchTab === 'list'}" role="tabpanel" aria-labelledby="nav-list-tab">
                            
                            <app-attributes-mapping-list ></app-attributes-mapping-list>

                        </div>

                        <!-- CREATE/EDIT -->
                        <div class="tab-pane fade" id="nav-actions" [ngClass]="{'show active': switchTab === 'actions'}" role="tabpanel" aria-labelledby="nav-actions-tab">

                            <app-attributes-mapping-actions></app-attributes-mapping-actions>

                        </div>

                </div>

            </div>
        </div>

    </div>
</div>